import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";

const COLORS = {
  HIK: "#cc0000",
  DAHUA: "#0066cc",
  AXIS360: "#666666",
  GENERIC_IP: "#888888",
  HANWHA: "#ff6600",
  ELBAC: "#996633",
  NEOLINK: "#3399ff",
  SAMSUNG: "#1428a0",
  MAGIC_OLD: "#9933cc",
  MAGIC_NEW: "#cc33ff",
  XVR: "#333333",
  HAKOO: "#33aa55",
  TVT: "#777777",
  UNIVIEW: "#888899",
};

export default function BrandTag({ brand }) {
  if (!brand) return null;
  const name = typeof brand === "string" ? brand : brand.name;
  const bg = COLORS[name] || "#666";

  return (
    <Badge
      style={{
        backgroundColor: bg,
        color: "white",
        fontSize: "0.7rem",
        fontWeight: 600,
      }}
      pill
    >
      {name}
    </Badge>
  );
}

BrandTag.propTypes = {
  brand: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string.isRequired })]),
};
